import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SET_CONFIG_LUMN_LIST } from './url-constants';

type setConfigureLuminairesListEndpointSpecifications = ApiEndpointSpecification;
export const setConfigureLuminairesListEndpointSpecification: setConfigureLuminairesListEndpointSpecifications = {
    url: SET_CONFIG_LUMN_LIST,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'SetConfigLuminariesListRequestParams',
    requestBodySchemaName: 'SetConfigLuminariesListRequestBody',
    okResponseSchemaName: 'SetConfigLuminariesListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeSetConfigureLuminairesList = Helpers.makeApiRequestFn<
    Types.SetConfigureLuminariesListRequestParams,
    Types.SetConfigureLuminariesListRequestBody,
    Types.SetConfigureLuminariesListOkResponse
>(setConfigureLuminairesListEndpointSpecification);
